import React from 'react';
import './App.scss';



import {
    Navbar, LandingPage, GetImage, Section, Half, Full, ContactInfo, Card, Row, NavbarTab, ContactPhone, ContactEmail,
    ContactPlace
    //Here write components you want to use
    //e.g. Section, LandingPage, Full, Half
} from '@janskvaril/gabro-framework'



function App() {
    return (
        <div>

            <Navbar bg="#f9a825" color="#002171" bgFilter="blur(5px)">
                <NavbarTab type="brand">Kovošrot Dolák s.r.o.</NavbarTab>
                <NavbarTab type="tab" link="#about_us">Provozovny</NavbarTab>
                <NavbarTab type="tab" link="#services">Co vykupujeme</NavbarTab>
                <NavbarTab type="tab" link="#cenik">Další služby</NavbarTab>
                <NavbarTab type="tab" link="#contact">Kontakt</NavbarTab>
            </Navbar>

            <LandingPage bg={GetImage(require("./iron.jpg"))} version="v3" color="rgba(250,250,250,0.9)" orientation="left"
                orientationMobile="top" blockColor="rgba(33, 33, 33, 0.5)" blockOrientation="top" blockShape="crossed">

                <h1 style={{ color: "#FDCA40", textShadow: "2px 2px 6px black" }}>Kovošrot Dolák s.r.o.</h1>
                <h2 style={{ color: "#33A1FD", textShadow: "2px 2px 6px black" }}>Výkup a zpracování druhotných surovin.</h2>
            </ LandingPage>
            <Section bg={GetImage(require("./imgs/metalbg2.jpg"))} styled color="rgba(250,250,250,0.7)">
                <Full bg="rgba(0,0,0,0.8)">
                    <h2>Upozornění</h2>
                    <h4 style={{color: "#FF0000"}}>Omezení výkupu u následujícího materiálu:</h4>
                    <h4>Celé tlakové nádoby pouze rozpůlené (vyšroubovat ventil už nestačí)</h4>
                    <h4>Bojlery pouze zbavené izolace (nutno rozříznout plechový obal a odstranit pěnu nebo vatu)</h4>
                    <h4>Pračky pouze bez betonového závaží (závaží je většinou na bubnu a ve spodní části pračky)</h4>


                </Full>
                <Half bg="rgba(0,0,0,0.8)">
                    <p style={{display: "none", color: "#FF0000"}}>Poslední výkup v provozovně <b>Rozstání</b> proběhne v sobotu 29.listopadu 2025, znovuzahájení výkupu březen 2026 (bude upřesněno).  </p>
                    <p style={{color: "#FF0000"}}>Zahájení výkupu v <b>Rozstání</b> proběhne v sobotu 14.3.2026, od 9:00 do 11:00  </p>
                    <p style={{display: "", color: "#FF0000"}}>V provozovně <b>Otaslavice</b> změna výkupní doby ve čtvrtek 15:00-16:00. Sobota zůstává.</p>
                   
                    <h4 style={{display: "none", textAlign: "center" }}>VÝKUP PAPÍRU OBNOVEN</h4>
                    <h5 style={{display: "none", textAlign: "center" }}>(nevykupujeme lepenku, kernoty, krabice, hřbety knih)</h5>
                 
                    <p style={{display: "none", color: "#FF0000"}}> V Rozstání je nově k dispozici nová digitální nájezdová váha pro osobní automobily, dodávky a
                        malotraktory s váživostí do 3000kg a přesností 1kg</p>

                </Half>
                <Half bg="rgba(0,0,0,0.8)" styled>
                    <p>VÝKUP PAPÍRU OBNOVEN - nevykupujeme lepenku, kernoty, krabice, hřbety knih</p>
                    <p> Od 1.3.2015 nelze za kovový odpad vyplácet hotovost, platba se provádí převodem na účet, nebo pomocí
                        poštovní poukázky (složenka typu C).
                        Nejjednodužší způsob je platba převodem, peníze jsou na účtu do 3 pracovních dnů. </p>
                    <p>Při prodeji veškerých kovů předložte občanský průkaz a nahlašte číslo účtu včetně kódu banky.</p>

                </Half>

            </Section>


            <Section bg={GetImage(require("./metal2.jpg"))} id="services" styled color="rgba(250,250,250,0.8)">
                <Full bg="rgba(0,0,0,0.7)">
                    <h2>Co vykupujeme?</h2>
                </Full>
                <Half bg="rgba(0,0,0,0.7)">

                    <h3>Železné kovy</h3>
                    <p>Ocel (tloušťka nad 6mm)</p>
                    <p>Litina upravená max 30x30x30 cm, litina neupravená</p>
                    <p>Lehký železný odpad (plechy)</p>
                    <p></p>
                    <p></p>
                    <p></p>
                    
                </Half>
                <Half bg="rgba(0,0,0,0.7)">
                    <h3>Neželezné kovy </h3>
                    <p>Hliník (odlitky, plech, dráty, folie/žaluzie/plechovky, elektrovodný)</p>
                    <p>Měď (opalovaná,nová čistá, dráty včetně izolace, karmy/chladiče)</p>
                    <p>Autobaterie (včetně kyseliny)</p>
                    <p>další barevné kovy jako mosaz, zinek, nerez, olovo, cín, bronz</p>
                    <p>Papír (pouze noviny, časpisy, letáky a kanc.papír, NE lepenka)</p>
                </Half>
                <Full bg="rgba(0,0,0,0.7)">
                    <p style={{ textAlign: "center" }}> <strong>Při prodeji veškerých kovů předložte občanský průkaz a
                        nahlašte číslo účtu včetně kódu
                        banky.</strong> </p>
                    <p style={{ textAlign: "center" }}> <strong> Upozorňujeme že nevykupujeme: autovraky, ledničky, nádoby
                        od barev, dopravní značení,
                        kanály a věci získané nelegálním způsobem. </strong> </p>
                </Full>


            </Section>
            <Section shadow={true} bg={GetImage(require("./imgs/metalbg2.jpg"))} id="about_us" styled
                color="rgba(250,250,250,0.7)">
                <Full bg="rgba(0,0,0,0.8)">
                    <h2>Provozovny</h2>
                </Full>
                <Half bg="rgba(0,0,0,0.8)" styled>
                    <h3>
                        Provozna Otaslavice 403</h3>
                    <p> Sběrna disponuje váhou do 500 kg s přesností 1kg.
                        Pro přesnější vážení menšího mnozství dražších kovů je k dispozici váha "decimálka" s přesností po
                        100g
                        K dispozici je také nová digitální mostová váha do 35t.
                    </p>
                    <p></p>
                    <p></p>


                    <h3>Otevírací hodiny:</h3>
                    <h3>Otaslavice</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Pondělí</td>
                                <td>po tel. dohodě</td>
                            </tr>
                            <tr>
                                <td>Úterý</td>
                                <td>po tel. dohodě</td>
                            </tr>
                            <tr>
                                <td>Středa</td>
                                <td>po tel. dohodě</td>
                            </tr>
                            <tr>
                                <td>Čtvrtek</td>
                                <td>15:00 - 16:00 <b style={{display: "", color: "#FF0000"}}>,v zimním období zkráceno</b></td>
                            </tr>
                            <tr>
                                <td>Pátek</td>
                                <td>po tel. dohodě</td>
                            </tr>
                            <tr>
                                <td>Sobota</td>
                                <td>13:00 - 15:00</td>
                            </tr>
                            <tr>
                                <td>Neděle</td>
                                <td>zavřeno</td>
                            </tr>
                        </tbody>
                    </table>



                </Half>
                <Half bg="rgba(0,0,0,0.8)" styled>
                    <h3>Provozovna Rozstání 331</h3>
                    <p> Sběrna se nachází v uličce "Stará hlavní cesta". Vjezd se nachází buď druhá odbočka naproti Obecního
                        úřadu, nebo z ulice u školy.
                        Po domluvě lze zpřístupnit velkou zadní bránu (jen za příznivého počasí).
                    </p>
                    <p>Ve sběrně je k dispozici váha s váživostí 200 kg s přesností 0,1kg a nájezdová váha pro osobní
                        automobily a dodávky s váživostí 3000kg a přesností 1kg.</p>

                    <h3>Otevírací hodiny:</h3>
                    <h3>Rozstání</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Pondělí</td>
                                <td>zavřeno</td>
                            </tr>
                            <tr>
                                <td>Úterý</td>
                                <td>15:00 - 17:00 <b style={{display: "none",color: "#FF0000"}}>, zavřeno od 1.12 do března 2026</b></td>
                            </tr>
                            <tr>
                                <td>Středa</td>
                                <td>zavřeno</td>
                            </tr>
                            <tr>
                                <td>Čtvrtek</td>
                                <td>zavřeno</td>
                            </tr>
                            <tr>
                                <td>Pátek</td>
                                <td>zavřeno</td>
                            </tr>
                            <tr>
                                <td>Sobota</td>
                                <td>9:00 - 11:00 <b style={{display: "none",color: "#FF0000"}}>, zavřeno od 1.12 do března 2026</b></td>
                            </tr>
                            <tr>
                                <td>Neděle</td>
                                <td>zavřeno</td>
                            </tr>
                        </tbody>
                    </table>

                </Half>
            </Section>
            <Section shadow={true} bg={GetImage(require("./metal2.jpg"))} id="cenik" color="white">
                <Full color="rgba(250,250,250,0.8)" styled bg="rgba(0,0,0,0.7)">
                    <h2> Další služby</h2>
                </Full>
                <Row bg="rgba(0,0,0,0.7)">

                    <Card iconBg="#303F9F" conBg="rgb(185, 183, 182 )" conColor="black" divBorder="none" icon={require("./imgs/truck.png")} > Odvoz materiálu
                    </Card>
                    <Card shadow iconBg="#303F9F"
                        conBg="rgb(185, 183, 182 )" conColor="black" divBorder="none" icon={require("./imgs/price.png")}>
                        Smluvní ceny
                    </Card>
                    <Card shadow iconBg="#303F9F" conBg="rgb(185, 183, 182 )"
                        conColor="black" divBorder="none" icon={require("./imgs/container.png")}> <p>Bezplatné přistavení
                            kontejneru při
                            větším množství</p>
                    </Card>

                    <Card shadow iconBg="#303F9F" conBg="rgb(185, 183, 182 )" conColor="black" divBorder="none"
                        icon={require("./imgs/fire.png")}> Rozpalování konstrukcí
                    </Card>
                    <Card shadow
                        iconBg="#303F9F" conBg="rgb(185, 183, 182 )" conColor="black" divBorder="none"
                        icon={require("./imgs/phone.png")}> Po tel. domluvě obsluha i mimo pracovní dobu
                    </Card>
                    <Card
                        shadow iconBg="#303F9F" conBg="rgb(185, 183, 182 )" conColor="black" divBorder="none"
                        icon={require("./imgs/weight.png")}> Vážení na mostových vahách
                    </Card> </Row>
            </Section>
            <Section
                id="contact" bg="#f9a825" color="#002171">
                <Full>
                    <h3 className="styled">Kontakt</h3>
                    <ContactInfo color="#002171">
                        <ContactPhone type="phone" name="Provozovna Otaslavice:"
                            number="602 890 553" />
                        <ContactPlace address="Otaslavice 403"
                            mapsUrl="https://www.google.com/maps/place/Otaslavice+403,+798+06+Otaslavice/@49.3864205,17.0696058,17z/data=!3m1!4b1!4m5!3m4!1s0x4712f84217a92ccd:0xa7d685e9f5da8d73!8m2!3d49.386417!4d17.0717945" />
                        <ContactPhone type="phone" name="Provozovna Rozstání:" number="607 767 626" />
                        <ContactPlace address="Rozstání 331"
                            mapsUrl="https://www.google.com/maps/place/Rozst%C3%A1n%C3%AD+331,+798+62+Rozst%C3%A1n%C3%AD/data=!4m2!3m1!1s0x4712f4e3108c7d1f:0xcadf9ca43b2d787c?sa=X&ved=2ahUKEwjhsojO7cjsAhXKSsAKHZoKBw0Q8gEwAXoECAwQAQ" />
                        <ContactEmail email="kovosrotdolak@seznam.cz" />
                    </ContactInfo>
                </Full>
            </Section>

        </div >
    );
}

export default App;